import { PageLoader } from 'components/common/PageLoader';
import { ComponentType } from 'react';

const withLoader = <P extends object>(WrappedComponent: ComponentType<P>) => {
  return (props: P) => {
    return (
      <>
        <PageLoader />
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <WrappedComponent {...props} />
      </>
    );
  };
};

export default withLoader;
